import { Component, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Person, SearchService } from 'ldt-people-api';
import { AuthService } from 'src/app/auth/service/auth.service';
import { NotificationService } from '../notification-service/notification.service';
import { Log } from 'src/app/logger.service';
import { PurchasedUsersService } from './purchased-users.service';

@Component({
    selector: 'app-person-profile',
    templateUrl: './person-profile.component.html',
    styleUrls: ['./person-profile.component.scss'],
    standalone: false
})
export class PersonProfileComponent {
  @Input() person: Person;
  isDialog: boolean = false;
  currentIndex: number = 0;
  people: Person[] = [];
  freePreview: boolean = true;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { person: Person; people: Person[]; currentIndex: number },
    private dialogRef: MatDialogRef<PersonProfileComponent>,
    private searchService: SearchService,
    protected authService: AuthService,
    private notify: NotificationService,
    private purchasedUsersService: PurchasedUsersService
  ) {
    this.person = this.data?.person;
    this.people = this.data?.people || [];
    this.currentIndex = this.data?.currentIndex || 0;
    this.isDialog = !!this.data;
    this.getCachedPerson();
  }

  private getCachedPerson() {
    Log.d('PersonProfileComponent', 'getCachedPerson', this.person);
    if ('linkedin' in this.person) {
      this.freePreview = false;
      return;
    }

    const cachedPerson = this.purchasedUsersService.getPerson(this.person.id!);
    if (cachedPerson) {
      this.person = cachedPerson;
      this.freePreview = false;
    }
  }

  unlockFullProfile() {
    this.searchService
      .getPersonByLdp(this.person.id!, this.authService.getSelectedOrgIdValue)
      .subscribe({
        next: (person) => {
          this.person = person.person!;
          this.purchasedUsersService.addPerson(this.person);
          this.freePreview = false;
        },
        error: (error) => {
          if (error.status === 402) {
            this.notify.error(
              'You have reached your free preview limit. Please upgrade to a paid plan to continue.'
            );
            return;
          }
          this.notify.error('Error fetching person. Please try again later.');
          Log.e(error);
        },
      });
  }

  close() {
    if (this.isDialog) {
      this.dialogRef.close();
    }
  }

  canNavigateBack(): boolean {
    return this.currentIndex > 0;
  }

  canNavigateForward(): boolean {
    return this.currentIndex < this.people.length - 1;
  }

  navigateBack() {
    if (this.canNavigateBack()) {
      this.freePreview = true;
      this.currentIndex--;
      this.person = this.people[this.currentIndex];
      this.getCachedPerson();
    }
  }

  navigateForward() {
    if (this.canNavigateForward()) {
      this.freePreview = true;
      this.currentIndex++;
      this.person = this.people[this.currentIndex];
      this.getCachedPerson();
    }
  }
}
